export default {

    routerPushToLogin(_this) {
        _this.$router.push('/signin')
    },
}